module.exports = __webpack_public_path__ + "img/logo.b7c2f548.png";